export default [{
  path: '/vacation-management',
  name: 'vacationManagement',
  meta: {
    layout: 'main'
  },
  component: () => import('@/views/vacationManagement/index')
}]
